/**
 * @file: makeOrderDraftFromContext.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import {
  OrderDraft,
  OrderExtra,
  OrderFlowContextProps,
  OrderForm,
} from '../types';

export function makeOrderDraftFromContext(
  context: OrderFlowContextProps,
): OrderDraft {
  const {
    formController: { form },
  } = context;
  return {
    id: context.draftId,
    timestamp: Date.now(),
    form: {
      licensePlateNo: form.licensePlateNo.value,
      vin: form.vin.value,
      chassisNo: form.chassisNo.value,
      mileage: form.mileage.value,
      serviceAgentInfo: form.serviceAgentInfo.value,
      dashboardImgUrl: form.dashboardImgUrl.value,
      vehicleInfo: form.vehicleInfo.value,
      remark: form.remark.value,
      estimatedFinishTime: form.estimatedFinishTime.value,
      tags: form.tags.value,
      customerName: form.customerName.value,
      customerMobile: form.customerMobile.value,
      customerType: form.customerType.value,
      carwashType: form.carwashType.value,
      returnType: form.returnType.value,
      oldPartDisposalType: form.oldPartDisposalType.value,
      reservationType: form.reservationType.value,
      reservationId: form.reservationId.value,
      insuranceExpiryDate: form.insuranceExpiryDate.value,
      isSpecialLicensePlateNo: form.isSpecialLicensePlateNo.value,
      isNonStandardVin: form.isNonStandardVin.value,
    },
    lastVehicleInfo: context.lastVehicleInfo$.value,
    vehicleImageUrl: context.vehicleImageUrl$.value,
    orderDetail: context.orderDetail$.value,
    ocrImageInfo: {
      licensePlateNo: context.ocrImageInfo.licensePlateNo$.value,
      vin: context.ocrImageInfo.vin$.value,
    },
  };
}

export function isOrderDraftEmpty(draft: OrderDraft) {
  return Boolean(
    isOrderFormEmpty(draft.form) &&
      (draft.orderDetail == null || isOrderDetailEmpty(draft.orderDetail)) &&
      !draft.vehicleImageUrl &&
      !draft.lastVehicleInfo &&
      !draft.ocrImageInfo?.licensePlateNo &&
      !draft.ocrImageInfo?.vin,
  );
}

function isOrderDetailEmpty(orderDetail: OrderExtra) {
  return Boolean(
    !orderDetail.preInspection?.length &&
      !orderDetail.extendedProps?.length &&
      !orderDetail.serviceSubjects?.length,
  );
}

export function isOrderFormEmpty(form: OrderForm) {
  return Boolean(
    !form.licensePlateNo &&
      !form.vin &&
      !form.mileage &&
      !form.dashboardImgUrl &&
      !form.vehicleInfo &&
      !form.remark &&
      !form.estimatedFinishTime &&
      !form.tags &&
      !form.customerName?.trim() &&
      !form.customerMobile?.trim() &&
      !form.customerType &&
      !form.carwashType &&
      !form.returnType &&
      !form.oldPartDisposalType &&
      !form.reservationType &&
      !form.insuranceExpiryDate,
  );
}
